import { useLingui, Trans } from '../../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import EmailActionLayout from '../../../components/molecules/EmailActionLayout.mjs';
import { useResetResendPasswordActions } from './useResetResendPasswordActions.mjs';

const PasswordDedupe = ()=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    const { email, resendResetPassword, sendMagicLink, goBack } = useResetResendPasswordActions();
    return /*#__PURE__*/ React__default.createElement(EmailActionLayout, {
        header: $__i18n._({
            id: "password.resetRequired.title"
        }),
        description: /*#__PURE__*/ React__default.createElement(Trans, {
            id: "password.resetRequired.content",
            message: "We want to make sure your account is secure and that it's really you logging in! A login link was sent to you at <bold>{email}</bold>.",
            components: {
                bold: /*#__PURE__*/ React__default.createElement("b", null)
            },
            values: {
                email
            }
        }),
        resend: resendResetPassword,
        sendMagicLink: sendMagicLink,
        goBack: goBack
    });
};

export { PasswordDedupe };
//# sourceMappingURL=PasswordDedupe.mjs.map
